import Vue from 'vue';
import Vuex from 'vuex';
import userModule from './userModule';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiHost: '',
    bearerToken: ''
  },
  getters: {
    hasBearerToken(state) {
      return state.bearerToken && state.bearerToken.length > 0;
    }
  },
  mutations: {
    initApiHost(state, apiHost) {
      state.apiHost = apiHost;
    },
    setBearerToken(state, bearerToken) {
      state.bearerToken = bearerToken;
      localStorage.setItem('bearerToken', bearerToken);
    },
    initBearerTokenFromStorage(state) {
      state.bearerToken = localStorage.getItem('bearerToken') || '';
    },
  },
  actions: {
    logout(context) {
      context.commit('setBearerToken', '');
      context.commit('user/clearUser');
    },
  },
  modules: {
    user: userModule
  },
  strict: process.env.NODE_ENV !== 'production'
});
